import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ViewUserPowerBiReportDetailsWrapper = styled.div`
  .user-role-email-report-grid {
    padding: 0 16px 30px 16px;

    ${responsive.MOBILE`
      padding: 0 16px 24px 16px;
    `}
  }
  
  .MuiAccordionSummary-expandIconWrapper {
    display: none;
  }

  .accordion-container {
    padding: 24px 16px 24px 16px;

    ${responsive.MOBILE`
      padding: 16px;
    `}

    .role-header-text {
      margin-top: 24px;
      color: ${COLORS.cirrus_black10};
      ${responsive.MOBILE`
          margin-top: 16px;
        `}
    }
  }
`;
